import {useState} from "react";

export const useConvertBase64 = (): {
  convertChangeHandler: (
    event: React.ChangeEvent<HTMLInputElement>,
    setValue: any,
    name: string,
    path: string
  ) => void;
  image: any;
} => {
  const [image, setImage] = useState();

  const convertChangeHandler = async (
    event: React.ChangeEvent<HTMLInputElement>,
    setValue: any,
    name: string,
    path: string
  ) => {
    const file = event.target?.files![0];
    const base64 = await convertBase64(file);
    setImage(base64);
    setValue(name, base64.split(",")[1]);
    setValue(path, file.name);
    event.target.value = "";
  };

  const convertBase64 = (data: Blob): Promise<any> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(data);
      reader.onload = () => {
        resolve(reader.result);
      };
      reader.onerror = (error) => {
        reject(error);
      };
    });
  };
  return {convertChangeHandler, image};
};
